import React from 'react'
import { Text } from 'native-base'
import type { StyleProp, TextStyle } from 'react-native'

const DateText: React.FC<{
  style?: StyleProp<TextStyle>;
  testID?: string;
}> = ({ children, style, testID }) => {
  return (
    <Text
      testID={testID}
      fontSize="2xs"
      fontWeight={400}
      fontFamily="Lato"
      color="dark"
      style={style}
    >
      {children}
    </Text>
  )
}

export default DateText
